import axios from "axios";
var apiEndpoint = "https://ceol.theohennessy.com";
if (process.env.VUE_APP_API)
  apiEndpoint = process.env.VUE_APP_API
const axiosInstance = axios.create({
  baseURL: apiEndpoint + "/api",
  headers: {
    "Content-Type": "application/json",
  },
});

export { axiosInstance as default, apiEndpoint };